import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'src/app/shared/shared.module';
import { UsersRoutingModule } from './users-routing.module'

import { UsersComponent } from './users.component';
import { UsersDetailsComponent } from './components/users-details/users-details.component';
import { UsersViewComponent } from './components/users-view/users-view.component';
import { UserCreateComponent } from './components/user-create/user-create.component';


@NgModule({
  declarations: [
    UsersComponent, 
    UsersDetailsComponent,
     UsersViewComponent,
     UserCreateComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    UsersRoutingModule
  ]
})
export class UsersModule { }
